import { AfterViewInit, Component, ElementRef, HostBinding, input, viewChild } from "@angular/core";

@Component({
	selector: "stages-table-zoom",
	templateUrl: "./table-zoom.component.html",
})
export class TableZoomComponent implements AfterViewInit {
	@HostBinding("class.lg") dialogLgClass = true;
	@HostBinding("class.autoHeight") dialogAutoHeightClass = true;

	readonly tableZoomId = input.required<string>();

	private readonly spacerElement = viewChild.required<ElementRef>("spacer");

	ngAfterViewInit(): void {
		const clonedTable = $("#" + this.tableZoomId()).clone();
		clonedTable.css("display", "");
		clonedTable.insertBefore($(this.spacerElement().nativeElement));
	}
}
